import React from 'react';
import { title as titleStyle } from "../styles/SweetAlertStyles";
var Title = function (_a) {
    var children = _a.children;
    return React.createElement("h2", { style: titleStyle }, children);
};
export default Title;
//# sourceMappingURL=Title.js.map